/* raw layout hash: _default-web-layout-ms5erx:80d330c306aac10e2f3587633f4eccc368af42b1d45e34f021c9996c2afefaa6 */
import React from 'react';
import AppShell from './AppShell.jsx';
import { LAYOUT_MENUS } from './layoutMenus.js';

// Layout "_default-web-layout-ms5erx" — renders its page content through the router outlet.
export default function DefaultWebLayoutMs5erx() {
  return <AppShell layoutName="_default-web-layout-ms5erx" menu={LAYOUT_MENUS['_default-web-layout-ms5erx']} />;
}
